import { Dialog } from "@headlessui/react";
import { useNavigate } from "react-router";

import DialogBackdrop from "./DialogBackdrop";
import Countdown from "react-countdown";
import config from "config/config";

const SessionRefresherModal = ({
  modalState,
  setModalState,
  extendSession,
}) => {
  let navigate = useNavigate();

  const sessionTimeoutRenderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      setModalState(false);
      navigate("/?type=sessionTimeOut");
      return;
    } else {
      return (
        <>
          <button
            className="ui-btn-secondary ui-btn-min-w mt-4"
            onClick={() => LogOut()}
          >
            Log Out (0{minutes}:{seconds < 10 ? `0${seconds}` : seconds})
          </button>
        </>
      );
    }
  };
  const LogOut = () => {
    setModalState(false);
    navigate("/");
  };

  return (
    <>
      <Dialog open={modalState} onClose={() => null} className="ui-dialogs">
        <DialogBackdrop />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel
            role="dialog"
            aria-modal="true"
            className="ui-default-dialog"
          >
            <Dialog.Title className="font-body text-xl font-bold text-left">
              Your session is about to expire
            </Dialog.Title>
            <hr />
            <Dialog.Description>
              For information safety, the session is set to expire every two
              hours. You can extend your session by clicking Extend button
              below., or clicking on Log out will log you out and redirect you
              to the landing page. If no response is received in 5 minutes, you
              will be automatically logged out.
            </Dialog.Description>
            <div className="block text-right">
              <button
                className="ui-btn-primary ui-btn-min-w mt-4"
                onClick={() => extendSession()}
              >
                Extend
                <span className="sr-only"> Session for 30 minutes</span>
              </button>
              <Countdown
                date={Date.now() + parseInt(config.LOGOUT_TIMEOUT)}
                renderer={sessionTimeoutRenderer}
              />
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
};

export default SessionRefresherModal;
